export default __webpack_public_path__ + "static/media/album-image-2.831b9976.svg";